import { useTranslation } from 'react-i18next';
import { CalendarRange } from 'lucide-react';
import { formatDateTime } from '@/utils/datetime';
import { DATE_YMD_2 } from '@/configs/constants';
import { Button } from '@/components/common/Button';
import { News } from '@/types/news';
import { isFalsyValue } from '@/utils/utils';
import ImageNotFound from '@/assets/images/img_not_found.jpg';

interface HomeListItemProps {
    newsItems?: News[],
    onClickItem?: (item: News) => void,
    onSeeMore?: () => void
}

export default function HomeListItem({ newsItems, onClickItem, onSeeMore }: HomeListItemProps) {
    // hook
    const { t } = useTranslation();
    if (newsItems && newsItems?.length > 0) {
        return (
            <div className='flex flex-col gap-8'>
                <h3 className='title-1 text-center'>{t('words_title.news')}</h3>
                <div className='grid grid-cols-1 xsm:grid-cols-2 xl:grid-cols-3 gap-6'>
                    {
                        newsItems?.map((item) => {
                            return <Item key={item.id} item={item} onClickItem={onClickItem} />;
                        })
                    }
                </div>
                <div className='self-center'>
                    <Button variant='outline' className='p-0 h-fit px-6 py-2 border-black-1' onClick={onSeeMore}>{t('button.see_more')}</Button>
                </div>
            </div>
        );
    }
    return null;
};

interface ItemProps {
    item: News,
    onClickItem?: (item: News) => void
}

const Item = ({ item, onClickItem }: ItemProps) => {
    // hook
    const { t } = useTranslation();
    const handleOnClickItem = () => {
        if (onClickItem) {
            onClickItem(item);
        }
    };
    return (
        <div className='flex flex-col gap-4 cursor-pointer' onClick={handleOnClickItem}>
            <img
                className='rounded-xl max-h-[428px] aspect-[630/428]'
                src={isFalsyValue(item.image) ? ImageNotFound : item.image}
                alt='thumnail'
            />
            <div className='flex gap-4 content-center'>
                <div className='text-sm px-2 py-[0.375rem] bg-red-3 text-background-3 rounded-[2.125rem]'>{t('words_title.new_attention')}</div>
                <div className='flex gap-1 flex-wrap content-center'>
                    <CalendarRange className='self-center' />
                    <p className='text-base'>{formatDateTime(item.createdAt, DATE_YMD_2)}</p>
                </div>
            </div>
            <p className='title-2 line-clamp-1'>{item.title}</p>
        </div>
    );
};
